<template>
    <div class="quill-editor-box">
        <!-- 图片上传组件辅助 -->
        <el-upload
                class="avatar-uploader quill-img"
                :action="uploadImgUrl"
                name="file"
                :headers="headers"
                :show-file-list="false"
                :on-success="quillImgSuccess"
                :on-error="uploadError"
                :before-upload="quillImgBefore"
                accept='.jpg,.jpeg,.png,.gif'
        ></el-upload>

        <el-dialog
                :visible.sync="dialogVisible"
                width="50%"
        >
            <div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="插入数据" prop="data" v-if="options&&options.length">
                        <el-cascader
                                v-model="ruleForm.data"
                                :key="cascaderKey"
                                :options="options"
                                @change="handleChange"
                                :props="{
                                    label:'name',
                                    value:'id',
                                    children:'list'
                                }"
                        ></el-cascader>
                    </el-form-item>

                    <template v-if="ruleDetails">
                        <el-form-item label="数据格式">
                            <el-input
                                    v-model="ruleDetails.param"
                                    disabled
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    disabled
                                    v-model="ruleDetails.remark">
                            </el-input>
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">插 入</el-button>
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="interfaceDialogVisible"
                width="50%"
        >
            <div>
                <el-form :model="interfaceForm" :rules="interfacerules" ref="interfaceForm" label-width="100px"
                         class="demo-ruleForm">
                    <el-form-item label="插入接口" prop="data" v-if="interfaceoptions&&interfaceoptions.length">
                        <el-cascader
                                v-model="interfaceForm.data"
                                :key="interfacecascaderKey"
                                :options="interfaceoptions"
                                @change="handleInterfaceChange"
                                :props="{
                                     label:'title',
                                    value:'menuId',
                                    children:'children',
                                    checkStrictly :true
                                }"
                        ></el-cascader>
                    </el-form-item>

                    <template v-if="interfaceDetails">
                        <el-form-item label="数据格式">
                            <el-input
                                    v-model="interfaceDetails.apiParam"
                                    disabled
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    disabled
                                    v-model="interfaceDetails.apiRemark">
                            </el-input>
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="interfaceDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitInterfaceForm('interfaceForm')">插 入</el-button>
            </div>
        </el-dialog>

        <!-- 富文本组件 -->
        <quill-editor
                class="editor"
                v-model="content"
                ref="quillEditor"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @change="onEditorChange($event)"
        ></quill-editor>
    </div>
</template>

<script>
    import {getToken} from '@/utils/auth'

    // 工具栏配置
    const toolbarOptions = [
        ["bold", "italic", "underline", "strike"],       // 加粗 斜体 下划线 删除线
        ["blockquote", "code-block"],                    // 引用  代码块
        [{list: "ordered"}, {list: "bullet"}],       // 有序、无序列表
        [{indent: "-1"}, {indent: "+1"}],            // 缩进
        [{size: ["small", false, "large", "huge"]}],   // 字体大小
        [{header: [1, 2, 3, 4, 5, 6, false]}],         // 标题
        [{color: []}, {background: []}],             // 字体颜色、字体背景颜色
        [{align: []}],                                 // 对齐方式
        [{'font': []}],
        [{'script': 'sub'}, {'script': 'super'}],
        // ["link", "image"],                       // 链接、图片、视频
        ["link"],                       // 链接、图片、视频
        ["clean"],
        ['insert', 'interface']
    ];

    import {quill, quillEditor} from "vue-quill-editor";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.bubble.css";


    function initButton() {      //在使用的页面中初始化按钮样式
        const insertButton = document.querySelector('.ql-insert');
        insertButton.style.cssText = "width:80px; border-radius:5px;padding:4px 10px";
        insertButton.innerText = "变量插入";
        // insertButton.classList.add('el-icon-edit-outline');
        insertButton.title = "变量插入";


        const interfaceButton = document.querySelector('.ql-interface');
        interfaceButton.style.cssText = "width:80px; border-radius:5px;padding:4px 10px";
        interfaceButton.innerText = "接口插入";
        // interfaceButton.classList.add('el-icon-edit-outline');
        interfaceButton.title = "接口插入";
    }

    var VueThis;
    var quillObj;
    import url from "../../utils/UrlApi"

    export default {
        name: 'editor',
        props: {
            /* 编辑器的内容 */
            value: {
                type: String
            },
            /* 图片大小 */
            maxSize: {
                type: Number,
                default: 4000 //kb
            }
        },
        components: {quillEditor},
        mounted() {
            initButton();
            VueThis = this
        },
        data() {
            return {
                content: this.value,
                // uploadImgUrl: "",
                editorOption: {
                    theme: "snow", // or 'bubble'
                    placeholder: "请输入内容",
                    modules: {
                        toolbar: {
                            container: toolbarOptions,
                            handlers: {
                                image: function (value) {
                                    if (value) {
                                        // 触发input框选择图片文件
                                        document.querySelector(".quill-img input").click();
                                    } else {
                                        this.quill.format("image", false);
                                    }
                                },
                                insert() {
                                    quillObj = this.quill
                                    VueThis.dialogVisible = true

                                    VueThis.ruleForm.data = []

                                    VueThis.getwordTemplateWordList()
                                },
                                interface() {
                                    quillObj = this.quill
                                    VueThis.interfaceDialogVisible = true
                                    VueThis.interfaceForm.data = []
                                    VueThis.getinterfaceList()
                                }
                            }
                        }
                    }
                },
                uploadImgUrl: process.env.VUE_APP_BASE_API + "/common/upload", // 上传的图片服务器地址
                headers: {
                    Authorization: getToken()
                },
                options: [],
                ruleForm: {
                    data: []
                },
                dialogVisible: false,
                rules: {
                    data: [
                        {required: true, message: '请选择插入的数据', trigger: 'change'}
                    ],
                },
                ruleDetails: '',
                cascaderKey: 1,


                interfaceForm: {
                    data: []
                },
                interfaceDialogVisible: false,
                interfacerules: {
                    data: [
                        {required: true, message: '请选择插入的数据', trigger: 'change'}
                    ],
                },
                interfaceDetails: '',
                interfacecascaderKey: 1,
                interfaceoptions: [],
            };
        },
        watch: {
            value: function () {
                this.content = this.value;
            }
        },
        methods: {
            onEditorBlur() {
                //失去焦点事件
            },
            onEditorFocus() {
                //获得焦点事件
            },
            onEditorChange() {
                //内容改变事件
                this.$emit("input", this.content);
            },
            handleChange(value) {
                console.log(value);
                let data = value[value.length - 1]

                //      查询详情
                this.$http.get(url.wordTemplateWordParamInfo, {params: {id: data}}).then(res => {
                    if (res.data.code === '200') {
                        this.ruleDetails = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },

            handleInterfaceChange(value) {
                console.log(value);
                let data = value[value.length - 1]

                //      查询详情
                this.$http.get(url.wordTemplateApiInfo, {params: {menuId: data}}).then(res => {
                    if (res.data.code === '200') {
                        this.interfaceDetails = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },


            // 富文本图片上传前
            quillImgBefore(file) {
                let fileType = file.type;
                if (fileType === 'image/jpeg' || fileType === 'image/png') {
                    return true;
                } else {
                    this.$message.error('请插入图片类型文件(jpg/jpeg/png)');
                    return false;
                }
            },

            quillImgSuccess(res, file) {
                // res为图片服务器返回的数据
                // 获取富文本组件实例
                let quill = this.$refs.quillEditor.quill;
                // 如果上传成功
                if (res.code == 200) {
                    // 获取光标所在位置
                    let length = quill.getSelection().index;
                    // 插入图片  res.url为服务器返回的图片地址
                    quill.insertEmbed(length, "image", res.url);
                    // 调整光标到最后
                    quill.setSelection(length + 1);
                } else {
                    this.$message.error("图片插入失败");
                }
            },
            // 富文本图片上传失败
            uploadError() {
                // loading动画消失
                this.$message.error("图片插入失败");
            },

            insert(data) {
                quillObj.focus();
                let range = quillObj.getSelection();
                console.log(range)
                if (range) {
                    if (range.length == 0) {
                        console.log('User cursor is at index', range.index);
                        quillObj.insertText(range.index, data);
                    } else {
                        var text = quillObj.getText(range.index, range.length);
                        quillObj.insertText(range.index, '123');
                        console.log('User has highlighted: ', text);
                    }
                } else {
                    console.log('User cursor is not in editor');
                }
            },


            getwordTemplateWordList() {
                this.cascaderKey++
                this.$http.get(url.wordTemplateWordList, {params: {}}).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)
                        this.options = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getinterfaceList() {
                this.cascaderKey++
                this.$http.get(url.menuCityTree, {params: {}}).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)
                        this.interfaceoptions = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        this.insert(this.ruleDetails.param)
                        this.dialogVisible = false
                        this.ruleDetails = ''

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

            submitInterfaceForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        this.insert(this.interfaceDetails.apiParam)
                        this.interfaceDialogVisible = false
                        this.interfaceDetails = ''

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

        }
    };
</script>

<style scoped lang="less">
    .quill-editor-box {
        height: 100%;
        margin: 0 20px;

    }
</style>
<style>

    .editor {
        line-height: normal !important;
        /*height: 192px;*/
        /*max-height: 400px;*/
        /*min-height: 200px;*/
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .editor .ql-container {
        flex: 1;
        overflow: auto;
    }

    .quill-img {
        display: none;
    }

    .ql-snow .ql-tooltip[data-mode="link"]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: "保存";
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode="video"]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: "14px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
        content: "10px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
        content: "18px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
        content: "32px";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: "文本";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: "标题1";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: "标题2";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: "标题3";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: "标题4";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: "标题5";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: "标题6";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: "标准字体";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
        content: "衬线字体";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
        content: "等宽字体";
    }
</style>
